export default __webpack_public_path__ + "static/media/tpc_calc_breakeven_tag.ae5a31bb.svg";